export const DESKTOP_BREAKPOINT_EM  = 58
export const MAX_MOBILE_PX  = 450
const MOBILE_MAX_WIDTH = 1024
export const DESKTOP_BREAKPOINT = `(min-width: ${MOBILE_MAX_WIDTH}px)`

export const ORDER_STATUS = {
  CANCELED: "Cancelled",
  REJECTED: "Rejected",
  PENDING: "Pending",
  ACCEPTED: "Open",
  CLOSED: "Closed"
}

export const ORDER_STATUS_LABEL = {
  ORDER_PLACED: "Order placed",
  [ORDER_STATUS.CANCELED]: "Order canceled",
  [ORDER_STATUS.REJECTED]: "Provider rejected",
  [ORDER_STATUS.PENDING]: "Waiting on provider",
  [ORDER_STATUS.ACCEPTED]: "Provider accepted"
}

export const ORDER_CANCELED_REJECTED = [ORDER_STATUS.CANCELED, ORDER_STATUS.REJECTED]
export const ORDER_ACCEPTED = [ORDER_STATUS.ACCEPTED, ORDER_STATUS.CLOSED]

export const ORDER_REJECTED_SUPPORT_URL = "https://support.realtor.com/s/article/qualia-usage-and-title-support-faqs#three"
